import { NgView } from "@app/di/decorators";
import { Token } from "@app/di/token";
import { ApiService } from "@app/services/api.service";
import { SearchService } from "@app/services/search.service";
import { ISearchScope, SearchController } from "@app/views/search.view";
import { IContact, ISavedSearch, meta } from "@models";
import { icons } from "@tools";

export interface IContactsScope extends ISearchScope<IContact> {

}

@NgView({
    token: Token.ContactsView,
    inherit: [Token.SearchView]
})
export class ContactsController extends SearchController<IContact> {
    constructor(
        $scope: IContactsScope,
        agg: SearchService) {

        super(
            $scope,
            agg
        );

        agg.$rootScope.setTitle(loc.contacts);

        agg.drawerService.pageTitle = loc.contacts;
        agg.drawerService.pageIcon = icons.user;

        agg.drawerService.setHelpUrl("Contacts");

        if (agg.$rootScope.user.canModifyCustomers) {
            agg.drawerService.addDrawer(icons.add, loc.add, () => agg.$state.go("kb.contactNew"));
            agg.drawerService.addDrawer(icons.clone, loc.clone, () => this.clone());
            agg.drawerService.addDrawer(icons.deleter, loc.deleter, () => this.deleteItems());
        }
    }

    public client(api: ApiService) {
        return api.contacts;
    }

    public newSearch(): ISavedSearch {
        return {
            modelType: meta.Contact.$name,
            sortField: "FirstName",
            descending: false,
            filters: this.getFiltersFromMeta(meta.Contact.$name, true),
            roles: []
        };
    }
}
